import { DialogActions, DialogTitle } from "@material-ui/core";
import React, { Component } from "react";
import styled from "styled-components";
import { AiGeneratedSlideType } from "../../../common/aiConstants";
import { Button } from "../../Components/Button";
import { Dropdown } from "../../Components/Dropdown";
import { IconButton } from "../../Components/IconButton";
import { MenuItem } from "../../Components/Menu";
import { TextField } from "../../Components/TextField";
import { WithLabel } from "../../Components/WithLabel";
import { BeautifulDialog, DialogContent } from "../../react/components/Dialogs/BaseDialog";
import { Gap10, Gap20 } from "../../react/components/Gap";
import { FlexBox } from "../../react/components/LayoutGrid";
import { AiSlideContentEditor } from "../CreatePresentation/GeneratePresentation/Components/AiSlideContentEditor";
import { CategoryController, SlideCategories } from "../../../common/SlideCategories/CategoryController";
import { ToggleSwitch } from "../../Components/ToggleSwitch";
import { marked } from "marked";

const EditSlideContainer = styled.div`
    width: 100%;

    textarea {
        resize: none;
        width: calc(100% - 20px);
        min-height: 300px;
        padding: 10px;
        font-family: Source Sans Pro;
        font-size: 16px;
        outline: none;
        line-height: 1.5;
        border: solid 1px #ccc;
    }
`;

const TextContainer = styled.div`
    background: #fff;
    border: solid 1px #ccc;
    padding: 20px;
    width: 100%;
    min-height: 200px;
`;

export class SlideAiDialog extends Component {
    constructor(props) {
        super(props);

        let metadata = props.slide.getMetadata() ?? {
            title: "Loading..."
        };

        let prompt = metadata.slidePrompt ?? metadata.slideContent ?? "";

        if (typeof prompt === "object") {
            prompt = JSON.stringify(prompt, null, 2);
        }
        prompt = marked.parse(prompt);

        this.state = {
            title: metadata.title,
            originalSlidePrompt: metadata.originalSlidePrompt,
            slidePrompt: prompt,
            // slideContent: props.canvas.getPrimaryElement()?.getCommonModel()?.toText() || "",
            slideType: "auto",
            previewModels: null,
            preserveExactText: false,
        };
    }

    render() {
        const { closeDialog, slide } = this.props;
        const { title, slidePrompt, originalSlidePrompt, slideType, previewModels, preserveExactText } = this.state;

        return (
            <BeautifulDialog closeDialog={closeDialog} maxWidth="md">
                <DialogTitle>Regenerate Slide</DialogTitle>
                <DialogContent>
                    <EditSlideContainer>
                        <WithLabel label="Slide Prompt" above left>
                            <TextContainer>
                                <AiSlideContentEditor text={slidePrompt} onChange={slidePrompt => this.setState({ slidePrompt })} />
                            </TextContainer>
                            {/*<textarea onChange={event => this.setState({ slideContent: event.target.value })} value={slideContent} />*/}
                        </WithLabel>
                        <Gap10 />
                        <FlexBox left middle fillWidth gap={20}>
                            <WithLabel label="Slide Type" tight>
                                <Dropdown value={slideType}
                                    onChange={slideType => this.setState({ slideType })}>
                                    <MenuItem key="auto" value="auto">Auto Detect</MenuItem>
                                    {Object.values(SlideCategories).map(type => <MenuItem key={type} value={type}>{type.toTitleCase()}</MenuItem>)}
                                </Dropdown>
                            </WithLabel>
                            <IconButton icon="add_circle" label="Add file..." />
                            <WithLabel tight label="Preserve Exact Text">
                                <ToggleSwitch value={preserveExactText} onChange={preserveExactText => this.setState({ preserveExactText })} />
                            </WithLabel>
                        </FlexBox>
                        <Gap20 />
                    </EditSlideContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => closeDialog(null)}>Cancel</Button>
                    <Button onClick={() => closeDialog(this.state)}>Regenerate Slide</Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
